<template>
  <div class="referral">
    <div class="subheading grey--text ma-6 mb-0"><h5>Balance swap</h5></div>
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6">
          <v-card max-width="600" class="pa-6 custom-card" flat>
            <h3>Balance vault transfer</h3>
            <VaultTransfer />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VaultTransfer from "@/components/wallet/VaultTransfer";
export default {
  components: { VaultTransfer },
  data() {
    return {};
  },
};
</script>
